// extracted by mini-css-extract-plugin
export var originalPrice = "_w9-0";